import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-correspondance-tracking',
  templateUrl: './correspondance-tracking.component.html',
  styleUrls: ['./correspondance-tracking.component.css']
})
export class CorrespondanceTrackingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/correspondance-tracking/correspondance-tracking.component.ts